import { jsonFetch } from "@/lib/helpers";
import { TaskType } from "@/models/task-types";
import { TASK_TYPES_URL } from "./api-url.constants";
import { TaskTypesApiResponse } from "./dtos/task-type.api.dto";
import { mapTaskTypeDTO } from "./mappers";

export const getTaskTypes = async (): Promise<TaskType[]> => {
  const response = await jsonFetch<TaskTypesApiResponse>(TASK_TYPES_URL);
  return response.data.map(mapTaskTypeDTO);
};
